export const env = {
  API_ZENDESK_WIDGET: process.env.NEXT_PUBLIC_API_ZENDESK_WIDGET as string,
  BB_S3_IMAGE_REGION: process.env.BB_S3_IMAGE_REGION || 'us-west-1',
  CMS_URL: process.env.NEXT_PUBLIC_CMS_URL as string,
  COUPLESIDE_STAGING_URL: process.env.NEXT_PUBLIC_COUPLESIDE_STAGING_URL as string,
  COUPLESIDE_URL: process.env.NEXT_PUBLIC_COUPLESIDE_URL as string,
  CUSTOMER_IO_API_KEY: process.env.CUSTOMER_IO_API_KEY as string,
  CUSTOMER_IO_SITE_ID: process.env.CUSTOMER_IO_SITE_ID as string,
  CUSTOMERIO_APP_API_KEY: process.env.CUSTOMERIO_APP_API_KEY,
  ELASTIC_ARTICLES: process.env.ELASTIC_ARTICLES as string,
  FIREBASE: { databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL as string },
  GCP_LIVE: process.env.GCLOUD_PROJECT === 'bridebookhq',
  IS_PRODUCTION_BUILD: process.env.NODE_ENV === 'production',
  LIVE: process.env.NEXT_PUBLIC_DATABASE === 'production',
  MIN_ARTICLES_COUNT: process.env.MIN_ARTICLES_COUNT as string,
  MONITORING_TOKEN: process.env.MONITORING_TOKEN || '',
  R2_ACCESS_KEY_ID: process.env.R2_ACCESS_KEY_ID || '',
  R2_SECRET_ACCESS_KEY: process.env.R2_SECRET_ACCESS_KEY || '',
  REDIS_HOST: process.env.REDIS_HOST as string,
  REDIS_PASS: process.env.REDIS_PASS || '',
  REDIS_PORT: process.env.REDIS_PORT as string,
  REDIS_URL: process.env.REDIS_URL || '',
  REDIS_USER: process.env.REDIS_USER as string,
  S3_API_IMAGE_ACCESS_KEY: process.env.S3_API_IMAGE_ACCESS_KEY as string,
  S3_API_IMAGE_SECRET_KEY: process.env.S3_API_IMAGE_SECRET_KEY as string,
  SECRET_COOKIE_PASSWORD: process.env.SECRET_COOKIE_PASSWORD as string,
  SENTRY: (process.env.NEXT_PUBLIC_SENTRY || process.env.NEXT_PUBLIC_SENTRY_DSN) as string,
  SKIP_REDIS: process.env.SKIP_REDIS !== undefined,
  TALKJS_APP_ID: process.env.NEXT_PUBLIC_TALKJS_APP_ID as string,
  TALKJS_SECRET_KEY: process.env.TALKJS_SECRET_KEY as string,
};
